export const REPORT_TYPE_ORDER = 0;
export const REPORT_TYPE_RETURN = 1;
export const REPORT_TYPE_GRIDWALL = 2;
export const REPORT_TYPE_TRANSACTIONS = 3;
export const REPORT_TYPE_CART = 4;

export const STATUS_IDLE = 0;
export const STATUS_DOWNLOADING = 1;
export const STATUS_COMPLETE = 2;
export const STATUS_ERROR = 3;
export const STATUS_NO_RESULTS = 4;
export const STATUS_GRIDWALL_TIMEOUT = 5;

export const STATUS = {
  [`${STATUS_IDLE}`]: '',
  [`${STATUS_DOWNLOADING}`]: 'downloads.status.downloading',
  [`${STATUS_ERROR}`]: 'downloads.status.error',
  [`${STATUS_COMPLETE}`]: 'downloads.status.complete',
  [`${STATUS_NO_RESULTS}`]: 'transactions.history.noResults',
  [`${STATUS_GRIDWALL_TIMEOUT}`]: 'downloads.status.gridwallTimeout'
};

export const INCLUDE_SIZES = 'sizes';
export const INCLUDE_IMAGES = 'images';
export const INCLUDE_UPC = 'upc';

export const CONTRACT_PERIOD_PAST = 'past';
export const CONTRACT_PERIOD_CURRENT = 'atonce';
export const CONTRACT_PERIOD_FUTURE = 'futures';

export const determineStatusByMessage = message => {
  let status = STATUS_ERROR;
  if (message === '400::No transactions found') status = STATUS_NO_RESULTS;
  if (message === 'Failed to fetch') status = STATUS_GRIDWALL_TIMEOUT;
  return status;
};
